export default function() {
	document.querySelectorAll('.menu-toggle, .overlay').forEach((element) => {
		element.addEventListener('click', () => {
			document.querySelectorAll('.main-header nav > ul, .overlay').forEach((target) => {
				target.classList.toggle('open');
			});
		});
	});
}
